import { __decorate, __metadata } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import * as VueElementLoading from "vue-element-loading";
import { Loader } from "@fastoche/ui-core/loader";
import { ThemeColorValue } from "@fastoche/ui-kit";
export const COMPONENT_NAME = "LvLoadingOverlay";
/**
 * A component indicating the loading state of a page or section.
 */
let LvLoadingOverlay = class LvLoadingOverlay extends Vue {
    /**
     * Whether the overlay is currently displayed.
     */
    get isActive() {
        return this.loader ? this.loader.active : this.active;
    }
};
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", String)
], LvLoadingOverlay.prototype, "text", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvLoadingOverlay.prototype, "active", void 0);
__decorate([
    Prop({ type: Object, required: false, default: () => null }),
    __metadata("design:type", Loader)
], LvLoadingOverlay.prototype, "loader", void 0);
__decorate([
    Prop({ type: String, required: false, default: () => ThemeColorValue.primary }),
    __metadata("design:type", Loader)
], LvLoadingOverlay.prototype, "color", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvLoadingOverlay.prototype, "fullscreen", void 0);
LvLoadingOverlay = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: {
            VueElementLoading,
        },
    })
], LvLoadingOverlay);
export default LvLoadingOverlay;
//# sourceMappingURL=script.js.map